module.exports = __webpack_public_path__ + "img/TargetCustomersSop.f93843d1.png";